import { createApp } from 'vue';
import ActionCableVue from 'actioncable-vue';
import * as Sentry from '@sentry/vue';

import Calendar from '../components/calendar.vue';
import HeaderUser from '../components/header-user.vue';
import store from '../store';
import router from '../router';

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('app') !== null) {
    const app = createApp({});

    app.use(store);
    app.use(router);
    app.use(ActionCableVue, { connectionUrl: '/cable' });
    app.component('Calendar', Calendar);
    app.component('HeaderUser', HeaderUser);

    if (import.meta.env.VITE_RAILS_ENV === 'production') {
      Sentry.init({
        app,
        dsn: import.meta.env.VITE_FRONT_SENTRY_DSN,
        attachProps: true,
      });
    }

    return app.mount('#app');
  }

  return null;
});
